export const getStream = async (constraints:MediaStreamConstraints):Promise<MediaStream> => {
  return await navigator.mediaDevices.getUserMedia(constraints);
} 